import React, { useState, useCallback } from "react";
import StarRatings from "react-star-ratings";
import googleLogo from "../assets/icons/google.png";
import { Box, makeStyles } from "@material-ui/core";
import { useGoogleRating } from "@customer-experience/cama-react";

const reviewURL =
  "https://www.google.de/search?hl=de&_ga=2.84133200.816593554.1617780110-1212779935.1616688031&q=freem&ludocid=8646785756697990377&lsig=AB86z5VIdfy6FLCpbUUEeK2MHRKG#lrd=0x47a84fa731a3f6d7:0x77ff8dd544e414e9,1";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    marginTop: theme.spacing(-1),
    [theme.breakpoints.up("sm")]: {
      marginRight: theme.spacing(3),
    },
  },
  details: {
    paddingLeft: theme.spacing(0.4),
    fontSize: "0.7rem",
  },
  reviews: {
    padding: 0,
    overflow: "auto",
    display: "block",
    color: "#FF9529",
    fontSize: "0.8rem",
    fontWeight: theme.typography.fontWeightMedium,
    fontFamily: "sans-serif",
    "& > .star-ratings": {
      marginLeft: theme.spacing(0.5),
    },
  },
}));

const GoogleWidget = () => {
  const classes = useStyles();
  const [ratingRef, setRatingRef] = useState();
  const rating = useGoogleRating({
    targetEl: ratingRef,
    placeId: "ChIJ1_ajMadPqEcR6RTkRNWN_3c",
  });

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const setRatinRefCb = useCallback((ref) => {
    if (ref) {
      setRatingRef(ref);
    }
  }, []);

  return (
    <div className={classes.root} onClick={() => openInNewTab(reviewURL)}>
      <img src={googleLogo} alt="Google Rating" width="30" height="30" />
      <Box className={classes.details}>
        Google Rating
        <div className={classes.reviews}>
          <span ref={setRatinRefCb}>
            {rating ?? "-"}
          </span>
          <StarRatings
            rating={rating ?? 0}
            starDimension="14px"
            starSpacing="1px"
            starRatedColor="#FF9529"
            numberOfStars={5}
            name="rating"
          />
        </div>
      </Box>
    </div>
  );
};

export default GoogleWidget;
